const permission = [{
  desc: '查询前端的页面权限',
  options: {
    url: '/permissionSet/querySysAndSelfDefPermissionSetForApi',
    method: 'post'
  }
}]
export default permission



// WEBPACK FOOTER //
// ./src/api/permission.js